/**
 * @freesewing/plugin-notches | v2.18.0
 * A FreeSewing plugin that provides front and back notch snippets
 * (c) 2021 Joost De Cock <joost@joost.at> (https://github.com/joostdecock)
 * @license MIT
 */
var name = "@freesewing/plugin-notches";
var version = "2.18.0";

const notches =
  '<g id="notch"><circle cy="0" cx="0" r="1.4" class="fill-note" /><circle cy="0" cx="0" r="2.8" class="note" /></g><g id="bnotch"><path d="M -1.1 -1.1 L 1.1 1.1 M 1.1 -1.1 L -1.1 1.1" class="note stroke-xl" /><circle cy="0" cx="0" r="2.8" class="note" /></g>';

var index = {
  name: name,
  version: version,
  hooks: {
    preRender: function (svg) {
      if (svg.attributes.get('freesewing:plugin-notches') === false) {
        svg.defs += notches;
        svg.attributes.add('freesewing:plugin-notches', version);
      }
    },
  },
};

export { index as default };
//# sourceMappingURL=index.mjs.map
